const ErrorService = {
    getMessage: (e: any) => {
        // Log detailed error to console for debugging
        console.error("Detailed Error:", e);

        if (e && e.response) {
            const status = e.response.status;
            let msg = e.response.data?.message || e.response.data?.error || "";
            if (typeof msg === 'object') {
                msg = JSON.stringify(msg);
            }
            const lowerMsg = msg.toLowerCase();

            // Custom friendly message mappings based on backend keys/messages
            if (lowerMsg.includes("no_access") || lowerMsg.includes("unauthorized") || status === 403) {
                return "Anda tidak memiliki izin (permission) untuk mengakses data ini atau melakukan tindakan ini. Silakan hubungi Administrator untuk mendapatkan akses.";
            }
            if (lowerMsg.includes("not_found") || status === 404) {
                return "Data atau sumber daya (resource) yang Anda cari tidak ditemukan.";
            }
            if (lowerMsg.includes("not_valid") || status === 422) {
                return "Data yang dimasukkan tidak valid. Silakan periksa kembali inputan Anda.";
            }
            if (lowerMsg.includes("vendor") && (lowerMsg.includes("verify") || lowerMsg.includes("verified") || lowerMsg.includes("unverified") || lowerMsg.includes("belum verify") || lowerMsg.includes("belum diverifikasi") || lowerMsg.includes("belum verifikasi"))) {
                return "Vendor ini belum diverifikasi. Silakan lakukan verifikasi terlebih dahulu.";
            }
            if (lowerMsg.includes("gagal menyetujui")) {
                return msg;
            }
            if (lowerMsg.includes("profit") && lowerMsg.includes("di bawah 5%")) {
                return "Persetujuan gagal: Profit penawaran berada di bawah 5% dan Anda tidak memiliki izin untuk menyetujui penawaran dengan profit rendah.";
            }
            if (lowerMsg.includes("penawaran anda sendiri") || lowerMsg.includes("penawaran Anda sendiri")) {
                return "Persetujuan gagal: Anda tidak memiliki izin untuk menyetujui penawaran Anda sendiri.";
            }
            if (lowerMsg.includes("penawaran sales lain")) {
                return "Persetujuan gagal: Anda tidak memiliki izin untuk menyetujui penawaran milik sales lain.";
            }
            if (lowerMsg.includes("offer not found") || lowerMsg.includes("penawaran tidak ditemukan")) {
                return "Penawaran (offer) tidak ditemukan.";
            }
            if (lowerMsg.includes("order deletion is not allowed")) {
                return "Penghapusan order tidak diizinkan.";
            }
            if (lowerMsg.includes("truck not found")) {
                return "Data truk tidak ditemukan.";
            }
            if (lowerMsg.includes("goods not found")) {
                return "Data barang tidak ditemukan.";
            }
            if (lowerMsg.includes("order commission not found")) {
                return "Data komisi order tidak ditemukan.";
            }
            if (lowerMsg.includes("request not found")) {
                return "Permintaan tidak ditemukan.";
            }
            if (lowerMsg.includes("bad_request") || status === 400) {
                return "Permintaan tidak valid. Silakan coba lagi.";
            }
            if (status === 401) {
                return "Sesi login Anda telah berakhir. Silakan masuk (login) kembali.";
            }
            return msg || "Terjadi kesalahan pada server. Silakan coba lagi nanti.";
        }

        if (e && e.request) {
            return "Koneksi gagal. Silakan periksa koneksi internet Anda.";
        }

        return e.message || e.toString();
    }
};

export default ErrorService;